/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { CommentContainer_comment$ref } from "./CommentContainer_comment.graphql";
import { IgnoredTombstoneOrHideContainer_comment$ref } from "./IgnoredTombstoneOrHideContainer_comment.graphql";
declare const _LocalReplyListContainer_comment$ref: unique symbol;
export type LocalReplyListContainer_comment$ref = typeof _LocalReplyListContainer_comment$ref;
export type LocalReplyListContainer_comment = {
    readonly id: string;
    readonly localReplies: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentRefs": CommentContainer_comment$ref & IgnoredTombstoneOrHideContainer_comment$ref;
    }> | null;
    readonly " $refType": LocalReplyListContainer_comment$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "LocalReplyListContainer_comment",
        "type": "Comment",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "localReplies",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Comment",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "kind": "FragmentSpread",
                                "name": "CommentContainer_comment",
                                "args": null
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "IgnoredTombstoneOrHideContainer_comment",
                                "args": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'abb85b8d07968b2728457e7222ded964';
export default node;
